import { render, staticRenderFns } from "./HelloWorld.vue?vue&type=template&id=2ec9c7d5&scoped=true"
import script from "./HelloWorld.vue?vue&type=script&lang=js"
export * from "./HelloWorld.vue?vue&type=script&lang=js"
import style0 from "./HelloWorld.vue?vue&type=style&index=0&id=2ec9c7d5&prod&scoped=true&lang=css"
import style1 from "./HelloWorld.vue?vue&type=style&index=1&id=2ec9c7d5&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ec9c7d5",
  null
  
)

export default component.exports